import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { List, ListItem } from '@material-ui/core';
import { sendLogin } from '../../auth/Auth';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';

const styles = theme => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  pageTitle: {
    margin: '48px 0px 0px',
    paddingLeft: 20,
    textAlign: 'left',
    color: '#000000',
    fontSize: 24,
    fontWeight: 700
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  listForm: {
    display: 'block',
    paddingBottom: 0,
    paddingTop: 14
  },
  itemForm: {
    display: 'block',
    padding: '16px 20px 8px'
  },
  btnBtom: {
    padding: '36px 20px 60px 20px'
  },
  labelControl: {
    marginTop: 16
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  imageBox: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '39px 40px',
    gridAutoRows: '1fr'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  },
  imageChoose: {
    border: `5px solid ${theme.palette.primary.main}`
  },
  imageNotChoose: {
    border: `5px solid white`
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('imageChooseId', 'setImageChooseId', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    menuImageSampleList,
    imageChooseId,
    setImageChooseId,
    setPreviewImage,
    handleClose,
    setIsImageDefault,
    setImageError
  }) => {
    const handleAddImage = () => {
      const imageTemp = menuImageSampleList.find(
        image => image.menuImageSampleId === imageChooseId
      ).image;
      setPreviewImage(imageTemp);
      setIsImageDefault(true);
      setImageError('');
      handleClose();
    };

    return (
      <>
        <div className={classes.root}>
          <div>
            <Typography className={classes.pageTitle}>
              メニュー画像選択
            </Typography>
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <List component="nav" className={classes.listForm}>
              <ListItem className={classes.itemForm}>
                <Typography component="div" className={classes.imageBox}>
                  {menuImageSampleList.map(image => {
                    return (
                      <div
                        key={image.menuImageSampleId}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setImageChooseId(image.menuImageSampleId);
                        }}
                        aria-hidden="true"
                        className={
                          imageChooseId === image.menuImageSampleId
                            ? classes.imageChoose
                            : classes.imageNotChoose
                        }
                      >
                        <img
                          src={image.image}
                          alt="image-menu-sample"
                          className={classes.image}
                          aria-hidden
                        />
                      </div>
                    );
                  })}
                </Typography>
              </ListItem>
            </List>
          </Paper>
          <div className={classes.btnBtom}>
            <CancelButton color="primary" onClickAction={handleClose} />
            <ConfirmButton
              consent={imageChooseId}
              onClickAction={handleAddImage}
            />
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
